const isLteMB =
  (n: number) =>
  (size: number): boolean => {
    return size / 1024 / 1024 <= n;
  };

export default isLteMB;
